import React, { PropTypes, Component } from 'react';
import cn from 'classnames';
import './styles.scss';


/**
 * This class is used to display a system message. the data related to the
 * message will be passed to props. This includes.
 *
 * type: the type of message (sets the color and icon)
 * body: the contents of the message
 */

export class Messagebar extends Component {
  componentWillMount() {
    this.timer = setTimeout(() => {
      this.timer = null;
      this.props.remove(this.props.index);
    }, 5000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  render() {
    return (
      <div className={cn('messagebar', this.props.className)}>
        <p>{this.props.body}</p>
      </div>
    );
  }
}

Messagebar.propTypes = {
  remove: PropTypes.func,
  className: PropTypes.string,
  body: PropTypes.string,
  index: PropTypes.number,
};

export default Messagebar;



// WEBPACK FOOTER //
// ./src/components/shared/messagebar/main.jsx